import styled from 'styled-components'

export const TooltipBubble = styled.div`
	position: fixed;
	background-color: #f8d7da;
	color: #721c24;
	border: 1px solid #f5c6cb;
	border-radius: 4px;
	padding: 6px 12px;
	font-size: 13px;
	white-space: nowrap;
	z-index: 1000;
	pointer-events: none;
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
`
